import { CompanionAccommodationExtent } from '@mews-commander/enums';
import { ReservationOptions } from '@mews-commander/types';
import { createHandler } from '@mews/std';

export const isOnlineCheckedIn = createHandler({
    [CompanionAccommodationExtent.All]: ({ allCompanionsCheckedIn }: ReservationOptions) => allCompanionsCheckedIn,
    [CompanionAccommodationExtent.Any]: ({
        ownerCheckedIn,
        anyCompanionCheckedIn,
        allCompanionsCheckedIn,
    }: ReservationOptions) => ownerCheckedIn || anyCompanionCheckedIn || allCompanionsCheckedIn,
});
